/**
 * type of tequilas
 */
export type TequilaType = 'SILVER' | 'GOLD' | 'ANEJO';

export const TequilaType = {
  Silver: 'SILVER' as TequilaType,
  Gold: 'GOLD' as TequilaType,
  Anejo: 'ANEJO' as TequilaType,
};
